<section id="nav" [ngClass]="{ 
  scroll: scrollFlag, 
  'navbar-transparent': navbarStyle === 'transparent',
  'navbar-dark': navbarStyle === 'dark',
  'navbar-white': navbarStyle === 'white'
}" class="navbar-section">
  <div class="container">
    <nav class="navbar">
      <div class="navbar-brand" [class.has-logo]="navbarStyle !== 'transparent'"
        [class.has-name]="navbarStyle === 'transparent'">
        <a routerLink="/" routerLinkActive="active">
          <ng-container *ngIf="navbarStyle === 'transparent'; else brandLogo">
            <span class="brand-name">Paredes y Asociados</span>
          </ng-container>
          <ng-template #brandLogo>
            <img src="/assets/images/logos/logo.png" alt="Paredes y Asociados Constructores" class="brand-logo" width="160" height="48" decoding="async">
          </ng-template>
        </a>
      </div>

      <div class="navbar-nav desktop-nav">
        <ul class="nav-links">
          <li class="nav-item">
            <a (click)="goTo('inicio')" [class.active]="isActiveSection('inicio')"
              class="nav-link">Inicio</a>
          </li>
          <li class="nav-item">
            <a (click)="goTo('nosotros')" [class.active]="isActiveSection('nosotros')"
              class="nav-link">Nosotros</a>
          </li>
          <li class="nav-item dropdown">
            <!-- <a href="javascript:void(0)" class="nav-link dropdown-toggle">Servicios</a> -->
            <a (click)="goTo('servicios')" [class.active]="isActiveSection('servicios')"
              class="nav-link">Servicios</a>

            <!-- <div class="dropdown-menu">
              <a href="javascript:void(0)" class="dropdown-item" (click)="scrollToSection('servicios')">Sector Salud</a>
              <a href="javascript:void(0)" class="dropdown-item" (click)="scrollToSection('servicios')">Industrial y Comercial</a>
              <a href="javascript:void(0)" class="dropdown-item" (click)="scrollToSection('servicios')">Sector Público</a>
              <a href="javascript:void(0)" class="dropdown-item" (click)="scrollToSection('servicios')">Vivienda y Desarrollos</a>
            </div> -->
          </li>
          <li class="nav-item">
            <a routerLink="proyectos" routerLinkActive="active" class="nav-link">Proyectos</a>
          </li>
          <li class="nav-item">
            <a routerLink="blog" routerLinkActive="active" class="nav-link">Blog</a>
          </li>
          <li class="nav-item">
            <a (click)="goTo('contacto')" [class.active]="isActiveSection('contacto')"
              class="nav-link">Contacto</a>

            <!-- <a routerLink="/contacto" routerLinkActive="active" class="nav-link">Contacto</a> -->
          </li>
        </ul>

        <div class="navbar-actions">
          <a class="btn btn-primary" routerLink="/cotizador">Solicitar Cotización</a>
        </div>
      </div>

      <div class="mobile-menu-toggle" 
      (click)="sidebarVisible = true">
        <i class="pi pi-bars"></i>
      </div>
    </nav>
  </div>
</section>

<!-- Mobile Sidebar Menu -->
<p-sidebar [(visible)]="sidebarVisible" position="right" class="mobile-sidebar">
  <div class="mobile-menu-content">
    <div class="mobile-menu-header">
      <img src="/assets/images/logos/logo.png" alt="Paredes y Asociados" class="mobile-logo" width="160" height="48" decoding="async">
      <button class="close-btn" (click)="sidebarVisible = false">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="mobile-menu-body">
      <nav class="mobile-nav">
        <a (click)=" goTo('inicio'); closeMobileMenu()" 
          [class.active]="isActiveSection('inicio')" class="mobile-nav-link">
          <i class="pi pi-home"></i>
          <span>Inicio</span>
        </a>
        <a (click)="goTo('nosotros'); closeMobileMenu()"
          [class.active]="isActiveSection('nosotros')" class="mobile-nav-link">
          <i class="pi pi-users"></i>
          <span>Nosotros</span>
        </a>

        <a (click)="goTo('servicios'); closeMobileMenu()"
          [class.active]="isActiveSection('servicios')" class="mobile-nav-link">
          <i class="pi pi-cog"></i>
          <span>Servicios</span>
        </a>

        <a routerLink="proyectos" (click)="closeMobileMenu()" routerLinkActive="active" class="mobile-nav-link">
          <i class="pi pi-building"></i>
          <span>Proyectos</span>
        </a>
        <a routerLink="blog" (click)="closeMobileMenu()" routerLinkActive="active" class="mobile-nav-link">
          <i class="pi pi-book"></i>
          <span>Blog</span>
        </a>
        <!-- <a (click)="scrollToSection('contacto'); closeMobileMenu()" routerLink="/" [class.active]="isActiveSection('contacto')" class="mobile-nav-link">
          <i class="pi pi-envelope"></i>
          <span>Contacto</span>
        </a> -->
      </nav>

      <div class="mobile-cta">
        <a class="mobile-cta-btn" (click)="goTo('contacto'); closeMobileMenu()">
          <i class="pi pi-envelope"></i>
          <span>Contacto</span>
        </a>
      </div>

      <div class="mobile-contact-info">
        <div class="contact-item">
          <i class="pi pi-phone"></i>
          <a href="tel:+525581083995">55 8108 3995</a>
        </div>
        <div class="contact-item">
          <i class="pi pi-envelope"></i>
          <a href="mailto:eparedes@paredesconstructores.com">eparedes&#64;paredesconstructores.com</a>
        </div>
      </div>

      <div class="mobile-social">
        <a href="https://www.facebook.com/ParedesYAsociados" target="_blank" class="social-link">
          <i class="pi pi-facebook"></i>
        </a>
        <a href="https://www.instagram.com/paredesyasociados/" target="_blank" class="social-link">
          <i class="pi pi-instagram"></i>
        </a>
        <a href="mailto:contacto@paredesyasociados.com" class="social-link">
          <i class="pi pi-envelope"></i>
        </a>
      </div>
    </div>

    <div class="mobile-menu-footer">
      <p>© 2025 Paredes y Asociados Constructores</p>
      <p>Más de 30 años construyendo confianza</p>
    </div>
  </div>
</p-sidebar>
